import React from "react";
import "./UpdateShimmer.css";

function UpdateShimmer() {
  return (
    <div className="bg-white p-4 rounded-3 shadow-sm">
      <div className="shimmer">
        <div className="d-flex align-items-center mb-4">
          <div className="shimmer-line w-25 me-3" />
          <div className="shimmer-button" />
        </div>
        <div className="row mb-4 align-items-center">
          <div className="col-md-3 text-center">
            <div className="shimmer-image" />
          </div>
          <div className="col-md-9">
            <div className="row row-cols-2 g-3">
              <div className="col"><div className="shimmer-line w-75" /></div>
              <div className="col"><div className="shimmer-line w-50" /></div>
              <div className="col"><div className="shimmer-line w-60" /></div>
              <div className="col"><div className="shimmer-line w-40" /></div>
              <div className="col"><div className="shimmer-line w-55" /></div>
            </div>
          </div>
        </div>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="shimmer-line w-90" />
            <div className="shimmer-line w-80" />
            <div className="shimmer-block h-120" />
          </div>
          <div className="col-md-6">
            <div className="shimmer-line w-85" />
            <div className="shimmer-line w-70" />
            <div className="shimmer-block h-120" />
          </div>
        </div>
        <div className="shimmer-block h-140 mt-4" />
      </div>
    </div>
  );
}

export default UpdateShimmer;


